import '@vkph/ui/styles.css';

import('./bootstrap').catch((error) => {
  console.error('Не удалось загрузить приложение:', error);

  const container = document.getElementById('root');

  if (container) {
    container.innerHTML = `
        <div style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            flex-direction: column;
            text-align: center;
          ">
          <h2>Произошла ошибка</h2>
          <p>Не удалось загрузить приложение.</p>
        </div>
      `;
  }
});
